import React, {h} from "preact";
import {Card} from "../../_common/layout";
import {t} from '../../_i18n';
import AlertBox from "../../_common/components/AlertBox/AlertBox";


function SentInviteComponent({invite}) {

    const string_email = t('INVITE_FRIEND_SENT_EMAIL').replace('{FRIEND_EMAIL}', invite?.email_friend)
    const getMessage = () => {
        switch (invite?.status) {
            case 'Done':
                return "Parece que la persona que has recomendado ya se ha matriculado. ¡Disfruta de tu descuento!";
            case 'Sent':
                return "En cuanto la persona que hayas recomendado se matricule, recibiréis el bono de descuento.";
            default:
                return '';
        }
    }

    const alertType = invite?.status === 'Done' ? 'success' : 'info'

    return (
        <Card smOnly={false} className='m-top p-bottom animation-appear full-width'>
            <div className='m-top' dangerouslySetInnerHTML={{__html: string_email}}/>
            <AlertBox type={alertType} className='m-top'>
                <div dangerouslySetInnerHTML={{__html: getMessage()}}/>
            </AlertBox>
            <div className='m-top m-bottom'>
                <p>{t('¡Muchas gracias por habernos recomendado!')}</p>
            </div>
        </Card>
    )
}


export default SentInviteComponent;
